import type { LegalDoc } from '../types';

// Transcribed 1:1 from "05 - Politica DMCA - Derechos de Autor.pdf" (MEC Vault/legal/app-legal).
// NOTE (internal, not rendered): before this page goes live, the DMCA Designated Agent must
// be registered at dmca.copyright.gov/osp/ (requires a physical mailing address).
export const dmca: LegalDoc = {
  slug: '/derechos-autor',
  title: 'Política de Derechos de Autor y Notificaciones DMCA',
  version: '1.0',
  updated: 'Julio de 2026',
  entity: 'Mi Envío Cuba',
  seoDescription:
    'Procedimiento de notificación y contra-notificación de derechos de autor (DMCA) de Mi Envío Cuba, conforme a 17 U.S.C. § 512.',
  closing: 'Fin de la Política DMCA.',
  sections: [
    {
      id: 'seccion-1',
      number: '1',
      title: 'Propósito',
      blocks: [
        {
          t: 'p',
          text: 'Mi Envío Cuba respeta los derechos de propiedad intelectual de terceros y espera que sus usuarios hagan lo mismo. Esta política describe el procedimiento para notificar a MEC de contenido publicado en la Aplicación que pudiera infringir sus derechos de autor, conforme a la Digital Millennium Copyright Act (“DMCA”), 17 U.S.C. § 512.',
        },
      ],
    },
    {
      id: 'seccion-2',
      number: '2',
      title: 'Procedimiento de notificación (Takedown Notice)',
      blocks: [
        {
          t: 'p',
          text: 'Si usted cree de buena fe que contenido publicado en la Aplicación infringe sus derechos de autor, envíenos una notificación por escrito que incluya los siguientes elementos requeridos por la DMCA (17 U.S.C. § 512(c)(3)):',
        },
        {
          t: 'ul',
          items: [
            '**Firma** física o electrónica del titular de los derechos o de una persona autorizada para actuar en su nombre.',
            '**Identificación de la obra protegida** que se alega infringida. Si múltiples obras en el mismo sitio se alegan infringidas, una lista representativa de dichas obras.',
            '**Identificación del material** que se alega infringiente o objeto de la actividad infringiente, con información razonablemente suficiente para permitirnos localizarlo (por ejemplo: URL, captura de pantalla, identificador de la publicación, nombre de la cuenta y descripción del contenido).',
            '**Información de contacto** razonablemente suficiente para permitirnos comunicarnos con usted: dirección postal, número de teléfono, y, si está disponible, correo electrónico.',
            '**Declaración de buena fe** de que el uso del material en la forma reclamada no está autorizado por el titular de los derechos, su agente, o la ley.',
            '**Declaración de exactitud**, bajo pena de perjurio, de que la información en la notificación es exacta y que usted está autorizado a actuar en nombre del titular de los derechos.',
          ],
        },
        { t: 'p', text: 'Envíe la notificación a nuestro Agente Designado:' },
        {
          t: 'ul',
          items: [
            '**Agente Designado DMCA:** Departamento Legal, MEC LLC',
            '**Correo:** support@mienviocuba.com',
            '**Teléfono:** +1 (786) 519-1709',
          ],
        },
        {
          t: 'p',
          text: '**Nota:** las notificaciones que no cumplan con los requisitos anteriores pueden ser inválidas conforme a la DMCA y pueden no recibir respuesta.',
        },
      ],
    },
    {
      id: 'seccion-3',
      number: '3',
      title: 'Respuesta al recibir una notificación',
      blocks: [
        { t: 'p', text: 'Al recibir una notificación válida bajo la DMCA:' },
        {
          t: 'ol',
          items: [
            'MEC removerá o deshabilitará el acceso al material presuntamente infringiente con prontitud razonable.',
            'MEC notificará al usuario que publicó el contenido de la remoción y le proporcionará copia de la notificación (redactando información personal identificable del notificante cuando corresponda).',
            'MEC mantendrá registro de la notificación conforme a las obligaciones legales de retención.',
          ],
        },
      ],
    },
    {
      id: 'seccion-4',
      number: '4',
      title: 'Procedimiento de contra-notificación',
      blocks: [
        {
          t: 'p',
          text: 'Si usted es el usuario cuyo contenido fue removido y considera que la remoción fue errónea (por ejemplo, porque tiene los derechos, o porque el uso es legítimo bajo la doctrina de uso justo “fair use”), puede enviar una contra-notificación que incluya:',
        },
        {
          t: 'ul',
          items: [
            'Firma física o electrónica suya.',
            'Identificación del material removido y su ubicación previa antes de la remoción.',
            'Declaración **bajo pena de perjurio** de que usted cree de buena fe que el material fue removido o deshabilitado por error o mala identificación.',
            'Su nombre, dirección y número de teléfono, y una declaración de que consiente a la jurisdicción del tribunal federal del distrito judicial donde reside (o, si reside fuera de EE. UU., del distrito donde se encuentra MEC — Distrito Sur de Florida), y de que aceptará el emplazamiento de la persona que envió la notificación original o de su agente.',
          ],
        },
        { t: 'p', text: 'Envíe la contra-notificación al Agente Designado indicado arriba.' },
        {
          t: 'p',
          text: 'Al recibir una contra-notificación válida, MEC enviará copia al notificante original. Si el notificante no presenta acción judicial contra el usuario dentro de 10 a 14 días hábiles de la contra-notificación, MEC podrá restaurar el material removido.',
        },
      ],
    },
    {
      id: 'seccion-5',
      number: '5',
      title: 'Política de infractores reincidentes',
      blocks: [
        {
          t: 'p',
          text: 'De conformidad con 17 U.S.C. § 512(i), MEC ha adoptado una política de terminación de cuentas de usuarios que sean infractores reincidentes de derechos de autor. Un usuario que reciba múltiples notificaciones válidas bajo la DMCA respecto de contenido distinto podrá tener su cuenta suspendida o terminada permanentemente, sin obligación de restauración.',
        },
      ],
    },
    {
      id: 'seccion-6',
      number: '6',
      title: 'Marcas comerciales y otros derechos de propiedad intelectual',
      blocks: [
        {
          t: 'p',
          text: 'Esta política aplica específicamente a reclamaciones de derechos de autor bajo la DMCA. Para reclamaciones relativas a **marcas comerciales, patentes, publicidad no autorizada, o difamación**, escríbanos a support@mienviocuba.com.',
        },
        {
          t: 'p',
          text: 'Describa la infracción con detalle e incluya evidencia del derecho que alega vulnerado (por ejemplo, número de registro de marca, fecha de registro, jurisdicción).',
        },
      ],
    },
    {
      id: 'seccion-7',
      number: '7',
      title: 'Falsas declaraciones',
      blocks: [
        {
          t: 'p',
          text: 'La DMCA (17 U.S.C. § 512(f)) impone responsabilidad a quien conscientemente presente notificaciones o contra-notificaciones falsas. Puede incurrir en responsabilidad por daños y perjuicios, honorarios de abogado y costos.',
        },
      ],
    },
    {
      id: 'seccion-8',
      number: '8',
      title: 'Modificaciones',
      blocks: [
        {
          t: 'p',
          text: 'MEC puede modificar esta política en cualquier momento. Los cambios materiales se notifican dentro de la Aplicación. La política vigente es la publicada en la Aplicación o el sitio web de MEC al momento de la notificación o contra-notificación.',
        },
        {
          t: 'p',
          text: 'Esta política forma parte integrante de los Términos de Servicio (v1.0) y se rige por el mismo derecho aplicable y foro descrito en aquellos.',
        },
      ],
    },
  ],
};
